import type { BackgroundJob } from "@metalmind-ab/mmagent-chat-ui";
import { readDocumentIdentity } from "./documentIdentity";

export const DOCUMENT_JOB_CHECK_BACK_MESSAGE =
  "Still working. Check back shortly.";

/**
 * Keep terminal jobs stable across the main and per-job streams. A completed
 * document without its identity may still be enriched by a history replay.
 */
export function shouldIgnoreBackgroundJobTerminalUpdate(
  job: BackgroundJob | undefined,
  nextStatus: "completed" | "failed",
): boolean {
  if (!job) return false;
  if (job.status === "failed" || job.status === "cancelled") return true;
  if (job.status !== "completed") return false;
  if (nextStatus === "failed") return true;

  const isDocumentJob =
    job.skillName === "generate_document" ||
    job.skillName === "generate_presentation";
  return !isDocumentJob || Boolean(readDocumentIdentity(job.result));
}
